var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stay-condition"},[(_vm.icon === 'dot')?_c('div',{staticClass:"dot mr-2"},[_c('div')]):_c('i',{staticClass:"mr-2 xs",class:_vm.classIcon}),_c('span',{class:`stay-condition__text text-${_vm.color}`,domProps:{"innerHTML":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }